<template>
  <div class="tools-list-box">
    <div class="tools-list">
      <div v-for="(tool, index) in tools" :key="index" class="tool-item" @click="handleClick(tool.command)">
        <div class="tool-icon">
          <i :class="tool.icon"></i>
        </div>
        <span>{{ tool.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const tools = ref([
  { name: '个人中心', icon: 'ri-account-circle-line', click: 'vip', command: '1' },
  { name: '赛道定位', icon: 'ri-trophy-line', click: 'vip', command: '10' },
  { name: '团队管理', icon: 'ri-team-line', click: 'user', command: '4' },
  { name: '版本公告', icon: 'ri-megaphone-line', click: 'version', command: '7' },
  { name: '邀请返利', icon: 'ri-emotion-laugh-fill', click: 'vip', command: '9' },
  { name: '意见反馈', icon: 'ri-phone-line', click: 'bindPhone', command: '2' },
  // { name: '帮助中心', icon: 'ri-question-line', click: 'securityCode', command: '6' },
  // { name: '退出登录', icon: 'ri-logout-circle-line', click: 'securityCode', command: '3' },
]);

const emit = defineEmits(['handleClick']);

function handleClick(command) {
  emit('handleClick', command); // 正确地发射事件，传递 'command' 作为参数
}
</script>

<style lang="scss" scoped>
.tools-list-box {
  width: 100%;
  height: 200px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px !important;
  // background-image: linear-gradient(180deg, #dae6fe 0%, #fff 100%) !important;
  position: relative;
}

.tool-item {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 6px 4px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 8px;

}

.tool-item:hover {
  background: #131313;
}

.tool-icon {
  background: $dark-gradient-primary-2;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 4px;
  margin-right: 10px;

  i {
    color: #fff;
    font-size: 16px;
  }
}

.tool-item span {
  font-size: 14px;
}
</style>
